import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import MockApi from "../../../../../shared/src/ranj/equalture/platform/MockAPI";
import MockPlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/MockPlatformAPIService";
import NGTConfigKey from "../ngt/base/NGTConfigKey";

export default class CollaborationPlatformMockAPIService extends MockPlatformAPIService {
    constructor(appModel, saveModel, config, dispatcher) {
        super(appModel, saveModel, config, dispatcher)
    }

    _createMockApi(environment) {
        const scenarios = this._config.getValue(NGTConfigKey.SCENARIOS);
        return new CollaborationMockAPI(environment, scenarios);
    }
}

class CollaborationMockAPI extends MockApi {
    constructor(environment, scenarios) {
        super(environment);
        this._scenarios = scenarios;
    }

    async getGlobalConfigurationAsync() {
        const configuration = await super.getGlobalConfigurationAsync();
        configuration.episodes = this._loadEpisodesStates();
        return configuration;
    }

    _loadEpisodesStates() {
        const str = window.localStorage.getItem(`${this._appId}.episodeStates`);
        if (getURLParameter("clear") === "1" || !str) {
            return this._scenarios.map(scenario => ({
                id: scenario.scenarioID,
                state: "started"
            }));
        } else {
            const states = JSON.parse(str);
            return states;
        }
    }
}